export default __webpack_public_path__ + "static/media/cupon-mnogodet.992d8063.pdf";